import { createReducer, on } from "@ngrx/store";
import { SiteOption, UserInformation } from "../user-typing";
import * as UserActions from "./user.actions";

export interface UserState {
	userInformation: UserInformation;
	loggedIn: boolean;
	currentSiteOption: SiteOption | null;
}

const initalUserState: UserState = {
	userInformation: {
		name: "",
		email: "",
		activeSiteId: "",
	},
	loggedIn: false,
	currentSiteOption: null,
};

export const userReducer = createReducer<UserState>(
	initalUserState,
	on(UserActions.loginUserSuccess, (state, { userInfo }) => {
		const options = userInfo.siteOptions ?? [];
		const currentSiteOption = options.find((site) => site.siteId === userInfo.activeSiteId) ?? options[0] ?? null;
		return {
			...state,
			loggedIn: true,
			currentSiteOption,
			userInformation: currentSiteOption ? { ...userInfo, activeSiteId: currentSiteOption.siteId } : userInfo,
		};
	}),
	on(UserActions.changeCurrentSiteSuccess, (state, { newSiteId }) => {
		// Find the new site in the options; as fallback keep the current selection
		const newCurrentSiteOption =
			state.userInformation.siteOptions?.find((site) => site.siteId === newSiteId) ?? state.currentSiteOption;
		return {
			...state,
			currentSiteOption: newCurrentSiteOption,
			userInformation: {
				...state.userInformation,
				activeSiteId: newCurrentSiteOption?.siteId ?? state.userInformation.activeSiteId,
			},
		};
	}),
);
